import React, { FC, useEffect, useState } from 'react';
import useEmployees from 'src/scenes/Rankings/hooks/useEmployees';
import Employee from 'src/interfaces/api/Employee';
import { Skeleton } from '@material-ui/lab';
import { Box, TableCell } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { IoMdTrophy as FirstIcon } from '@react-icons/all-files/io/IoMdTrophy';
import { IoMdRibbon as MedalIcon } from '@react-icons/all-files/io/IoMdRibbon';

interface Props {
  position: number;
  employeeId: string;
}

const EmployeeCell: FC<Props> = ({ employeeId, position }) => {
  const { fetchEmployee } = useEmployees();
  const [employee, setEmployee] = useState<Employee>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    fetchEmployee(employeeId)
      .then((employee) => {
        setEmployee(employee);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, [employeeId]);

  return (
    <TableCell>
      <Box display='flex' alignItems='center'>
        {position === 1 ? (
          <Box mr={1} color='#FFD700' clone>
            <FirstIcon size={18} />
          </Box>
        ) : position === 2 ? (
          <Box mr={1} color='#C0C0C0' clone>
            <MedalIcon size={18} />
          </Box>
        ) : position === 3 ? (
          <Box mr={1} color='#CD7F32' clone>
            <MedalIcon size={18} />
          </Box>
        ) : null}

        {loading ? (
          <Skeleton />
        ) : error ? (
          <div style={{ color: '#f44336' }}>{error}</div>
        ) : (
          employee && (
            <Link to={`/dashboard/user/${employee.legacyUserId}`}>
              <span>{`${employee.firstname} ${employee.lastname}`}</span>
            </Link>
          )
        )}
      </Box>
    </TableCell>
  );
};

export default EmployeeCell;
